import React, { Component } from 'react';

class ReferenceChangeCellTemplate extends Component {
    constructor(props){
        super();
        
        this.props = props;
    }

    render(){
        return (
            <td className="table__body--data left">
                {this.props.dataItem.validationFailed ? <i className="u-icon u-icon--sml u-icon--warning u-mar--right--sml" title={this.props.dataItem.errorMessage}></i> : null}
                {this.props.dataItem[this.props.field] ? 
                    (   this.props.dataItem.reviewed ?
                        <i className="u-icon u-icon--sml u-icon--active u-mar--right--sml"></i> :
                        <i className="u-icon u-icon--sml u-icon--active-blue u-mar--right--sml"></i>)
                : null}
                {this.props.dataItem.patientDetailId ? <i className="u-icon u-icon--sml u-icon--new-user"></i> : null}
            </td>
        );
    }
}

export default ReferenceChangeCellTemplate;